import { Pagination } from '@shared/types';
import { Dispatch, SetStateAction, UIEvent, useCallback, useEffect, useRef } from 'react';

interface useHandleScrollParams {
    isLoading: boolean;
    setPagination: Dispatch<SetStateAction<Pagination>>;
    allItemsFetched: boolean;
}

const useHandleScroll = ({ isLoading, setPagination, allItemsFetched }: useHandleScrollParams) => {
    const fetchLockRef = useRef(false);

    useEffect(() => {
        if (!isLoading) {
            fetchLockRef.current = false;
        }
    }, [isLoading]);

    const handleScroll = useCallback(
        (e: UIEvent<HTMLDivElement>) => {
            if (allItemsFetched || fetchLockRef.current || isLoading) return;

            const target = e.currentTarget;

            requestAnimationFrame(() => {
                const { scrollTop, scrollHeight, clientHeight } = target;
                if (scrollHeight <= clientHeight) return;

                const threshold = 5;
                const distanceToBottom = scrollHeight - scrollTop - clientHeight;

                if (distanceToBottom <= threshold) {
                    fetchLockRef.current = true;
                    setPagination((prev: Pagination) => ({ ...prev, pageIndex: prev.pageIndex + 1 }));
                }
            });
        },
        [allItemsFetched, isLoading, setPagination],
    );
    return handleScroll;
};

export default useHandleScroll;
